import { rem } from '@mantine/core';

export function iconSize(size: number): { width: string; height: string } {
  return { width: rem(size), height: rem(size) };
}
